import CircularProgress from '@mui/material/CircularProgress'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#CF003E',
    },
  },
})

const Spinner = (): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <CircularProgress />
    </ThemeProvider>
  )
}

export default Spinner
